import { useApp } from '../AppContext';
import './FriendsTab.css';

export default function FriendsTab() {
  const { friends, pendingRequests, acceptRequest, declineRequest } = useApp();

  // Open invite modal (stored in context via a simple global state trick)
  function openInvite() {
    document.getElementById('invite-modal')?.classList.add('visible');
  }

  const sorted = [...friends].sort((a, b) => (b.forgiven ? 1 : 0) - (a.forgiven ? 1 : 0));

  return (
    <div className="friends-tab">
      <div className="friends-header">
        <h2 className="friends-title">Your circle</h2>
        <button className="invite-chip" onClick={openInvite}>+ Invite</button>
      </div>

      {/* Pending requests */}
      {pendingRequests.length > 0 && (
        <div className="pending-section">
          <div className="section-label">Requests</div>
          {pendingRequests.map(req => (
            <div key={req.id} className="pending-item">
              <div className="avatar" style={{ width: 40, height: 40, fontSize: 16 }}>{req.initials}</div>
              <div className="friend-info">
                <div className="friend-name">{req.name}</div>
                <div className="friend-status">wants to join your circle</div>
              </div>
              <div className="pending-actions">
                <button className="pend-btn accept" onClick={() => acceptRequest(req.id)}>Accept</button>
                <button className="pend-btn decline" onClick={() => declineRequest(req.id)}>✕</button>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Friends list */}
      {friends.length === 0 ? (
        <div className="empty-state" style={{ paddingTop: 40 }}>
          <div className="empty-icon">🤝</div>
          <div className="empty-title">No circle yet</div>
          <div className="empty-sub">Invite people you know. When they join, you'll see when they forgive tonight.</div>
          <button className="btn btn-primary" style={{ marginTop: 20, width: 'auto', padding: '12px 28px' }} onClick={openInvite}>
            Invite someone
          </button>
        </div>
      ) : (
        <ul className="friends-list">
          {sorted.map(f => (
            <li key={f.id} className="friend-item">
              <div className="avatar friend-avatar" style={{ width: 44, height: 44, fontSize: 18 }}>
                {f.initials}
                <span className={`status-dot ${f.forgiven ? 'forgiven' : 'pending'}`} />
              </div>
              <div className="friend-info">
                <div className="friend-name">{f.name}</div>
                <div className={`friend-status${f.forgiven ? ' forgiven' : ''}`}>
                  {f.forgiven ? 'Forgave everyone tonight' : 'Not yet tonight'}
                </div>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
